import APIClient from '@/shared/http/clients/api'

// const resourceName = 'margem-contribuicao'
const resourceName = 'risco'
const APICore = process.env.APIBaseURLCore

const Search = (document = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?document=${document}&page=${index}&size=${limit}&sort=periodoMovimento,desc`, config)
const GetNivelRiscoCRL = (data, config = {}) => APIClient.get(`${APICore}/${resourceName}/risco-crl/?size=500`, config, data)

/**
 * @name RiscoRepository
 * @description Marge contribuição
 * @type { Respository }
 */
const RiscoRepository = {
  Search,
  GetNivelRiscoCRL
}

export default RiscoRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/risco.js